// Small custom icons (lucide-react does not ship Steering/Key variants we want)
import React from "react";
import { Car, KeyRound } from "lucide-react";

export const Steering = ({ size = 20 }) => <Car size={size} />;
export const Key = ({ size = 20 }) => <KeyRound size={size} />;
